import i18next from '@axess/limestone';
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";

export interface ILocalizationModuleInitData {
    cultureInfo: any;
    priceToDecimalDivisor: number;
    selectedLanguage: string;
    selectedLanguageId: number;
}

//Refactor this should definitely not be a module
@ModuleName("LocalizationModule")
export class LocalizationModule implements AxInit {
    private cultureInfo: any;
    private priceToDecimalDivisor: number;
    private selectedLanguage: string;
    private selectedLanguageId: number;
    private _i18nHelper = new I18nHelper();
    // To dynamically override Limestone's AxFormValidation implementation for i18Next fallback language resource in JSON file.
    private i18nextLanguage = {
        form: {
            required: this._i18nHelper.GetTranslation(Translations.I18NextRequired),
            msgRadioCheck: this._i18nHelper.GetTranslation(Translations.I18NextMsgRadioCheck),
            msgDropdown: this._i18nHelper.GetTranslation(Translations.I18NextMsgDropdown),
            msgPhoneRequired: this._i18nHelper.GetTranslation(Translations.I18NextMsgPhoneRequired),
            msgPasswordInvalid: this._i18nHelper.GetTranslation(Translations.I18NextMsgPasswordInvalid),
            msgPasswordUppercase: this._i18nHelper.GetTranslation(Translations.I18NextMsgPasswordUppercase),
            msgPasswordLowercase: this._i18nHelper.GetTranslation(Translations.I18NextMsgPasswordLowercase),
            msgPasswordDigit: this._i18nHelper.GetTranslation(Translations.I18NextMsgPasswordDigit),
            msgPasswordSpecChar: this._i18nHelper.GetTranslation(Translations.I18NextMsgPasswordSpecChar),
            msgEmail: this._i18nHelper.GetTranslation(Translations.I18NextMsgEmail),
            msgEmailGuestConfirm: this._i18nHelper.GetTranslation(Translations.I18NextMsgEmailGuestConfirm),
        },
        dropdown: {
            noresult: this._i18nHelper.GetTranslation(Translations.I18NextNoResult),
        },
    }

    async AxInit(init: ILocalizationModuleInitData): Promise<any> {
        this.cultureInfo = init.cultureInfo;
        this.priceToDecimalDivisor = init.priceToDecimalDivisor;
        this.selectedLanguage = init.selectedLanguage;
        this.selectedLanguageId = init.selectedLanguageId;

        // #region i18Next localization
        i18next.init({
            debug: false,
            fallbackLng: 'en',
            ns: ['limestone'],
            defaultNS: 'limestone',
            resources: {
                en: {
                    limestone: this.i18nextLanguage,
                },
            },
        });
        i18next.changeLanguage(this.selectedLanguage);
        // #endregion i18Next localization

        // #region JQuery Validation localization
        if (this.selectedLanguage !== 'en') {
            const $script = $('<script>', { src: `https://cdnjs.cloudflare.com/ajax/libs/jquery-validate/1.21.0/localization/messages_${this.selectedLanguage}.js` });
            $('body').append($script);
        }
        // #endregion JQuery Validation
   }

    getSelectedLanguage(): string {
        return this.selectedLanguage;
    }

    getSelectedLanguageId(): number {
        return this.selectedLanguageId;
    }

    getCultureInfo(): any {
        return this.cultureInfo;
    }

    getPriceToDecimalDivisor(): number {
        return this.priceToDecimalDivisor;
    }
}

